import React, {FC} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

const SubmitedTitleDiv = styled.div`
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.semibold};
`;

const SubmitedBodyDiv = styled.div`
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.normal};
  margin: 24px auto 0 auto;
`;

export const SurveySubmitted: FC = () => (
  <>
    <SubmitedTitleDiv>Thank you!</SubmitedTitleDiv>
    <SubmitedBodyDiv>Your feedback was sent.</SubmitedBodyDiv>
  </>
);
